/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElRadioGroup as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElInput as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElDatePicker as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/drone/src/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", null, "更新描述(新):"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "12px",
    "color": "orange",
    "white-space": "normal",
    "line-height": "20px"
  }
}, "Tips: 某些终端不能正常跳转后缀为.apk的链接")], -1);
const _hoisted_2 = {
  class: "dialog-footer"
};
import UEditor from '@ultra/share/components/UEditor/index.vue';
import { apiUsdkSwitchConfSaveVersion } from '@/api/usdk';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'addEditVersion',
  emits: ['success'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const formRef = ref();
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const type = ref('add');
    const form = ref({
      cid: undefined,
      updateTime: '',
      verCode: '',
      verName: '',
      updateDesc: '',
      updateDescNew: '',
      verSize: '',
      updateUrl: '',
      updateForce: 1,
      downloadType: 0,
      md5: ''
    });
    const oldForm = ref({});
    const gid = ref();
    const rules = reactive({
      cid: {
        required: true,
        message: '请选择渠道',
        trigger: 'change'
      },
      updateTime: {
        required: true,
        message: '请选择更新时间',
        trigger: 'change'
      },
      updateUrl: {
        pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
        message: '必须以http,https开头,且需符合URL规范,检查格式是否正确',
        trigger: 'change'
      },
      verCode: {
        required: true,
        message: '请填写版本号',
        trigger: 'change'
      },
      verName: {
        required: true,
        message: '请填写版本名',
        trigger: 'change'
      },
      updateDesc: {
        required: true,
        message: '请填写更新描述',
        trigger: 'changes'
      },
      verSize: {
        required: true,
        message: '请填写包体大小',
        trigger: 'changes'
      },
      updateForce: {
        required: true,
        message: '强选择更新类型',
        trigger: 'changes'
      }
    });
    const handleClose = formEl => {
      dialogVisible.value = false;
      if (!formEl) return;
      formEl.resetFields();
    };
    const disabledTime = current => {
      return current.getTime() < Date.now() - 1 * 24 * 3600 * 1000 + 20 * 60 * 1000;
    };
    const changeDownloadType = e => {
      if (type.value === 'edit') {
        if (e.target.value === 0) {
          form.value.updateUrl = oldForm.value.sourceUpdateUrl;
        } else {
          form.value.updateUrl = oldForm.value.updateUrl;
        }
      }
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          confirmLoading.value = true;
          const params = {
            ...form.value,
            updateTime: dayjs(form.value.updateTime).format('YYYY-MM-DD HH:mm:ss')
          };
          apiUsdkSwitchConfSaveVersion({
            gid: gid.value,
            ...params
          }).then(res => {
            if (res.code === 0) {
              emits('success');
              handleClose(formRef.value);
            }
            confirmLoading.value = false;
          });
        }
      });
    };
    const show = payload => {
      initForm();
      dialogVisible.value = true;
      type.value = payload.type;
      gid.value = payload.gid;
      if (payload.data) {
        oldForm.value = payload.data;
        form.value = {
          ...payload.data
        };
      }
    };
    const initForm = () => {
      form.value = {
        cid: undefined,
        updateTime: '',
        verCode: '',
        verName: '',
        updateDesc: '',
        updateDescNew: '',
        verSize: '',
        updateUrl: '',
        updateForce: 1,
        downloadType: 0,
        md5: ''
      };
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_GameChannelSelect = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_date_picker = __unplugin_components_2;
      const _component_el_input = __unplugin_components_3;
      const _component_el_radio = __unplugin_components_4;
      const _component_el_radio_group = __unplugin_components_5;
      const _component_el_form = __unplugin_components_6;
      const _component_el_button = __unplugin_components_7;
      const _component_el_dialog = __unplugin_components_8;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: `${_unref(type) === 'add' ? '添加' : '编辑'}版本`,
        width: "800px",
        "before-close": () => handleClose(_unref(formRef))
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = $event => handleClose(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: _unref(confirmLoading),
          type: "primary",
          onClick: _cache[12] || (_cache[12] = $event => handleOk(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(form),
          ref_key: "formRef",
          ref: formRef,
          rules: _unref(rules),
          "label-width": "200px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "选择渠道",
            prop: "cid"
          }, {
            default: _withCtx(() => [_createVNode(_component_GameChannelSelect, {
              modelValue: _unref(form).cid,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).cid = $event),
              gid: _unref(gid)
            }, null, 8, ["modelValue", "gid"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "更新时间",
            prop: "updateTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _unref(form).updateTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).updateTime = $event),
              type: "datetime",
              "disabled-date": disabledTime,
              placeholder: "选择更新时间",
              format: "YYYY/MM/DD HH:mm:ss",
              "value-format": "x"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "VersionName",
            prop: "verName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).verName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).verName = $event),
              placeholder: "VerSionName,如3.2.1，用于更新提示"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "VersionCode",
            prop: "verCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).verCode,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).verCode = $event),
              placeholder: "VerSionCode,如20，低于此版本号包体都将被更新"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "更新描述(老)",
            prop: "updateDesc"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _unref(form).updateDesc,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).updateDesc = $event),
              placeholder: "类似公告，用于更新提示",
              "auto-size": {
                minRows: 3
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            colon: false
          }, {
            label: _withCtx(() => [_hoisted_1]),
            default: _withCtx(() => [_createVNode(UEditor, {
              modelValue: _unref(form).updateDescNew,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).updateDescNew = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "包体大小",
            prop: "verSize"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).verSize,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).verSize = $event),
              placeholder: "如300M，用于更新提示"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "更新链接",
            prop: "updateUrl"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).updateUrl,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(form).updateUrl = $event),
              placeholder: "链接以http(s)://开头，更新时跳转外部浏览器进行下载"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "更新类型",
            prop: "updateForce"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).updateForce,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).updateForce = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("强更")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 0
              }, {
                default: _withCtx(() => [_createTextVNode("非强更")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "下载类型"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              onChange: changeDownloadType,
              modelValue: _unref(form).downloadType,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).downloadType = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 0
              }, {
                default: _withCtx(() => [_createTextVNode("内置下载")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("外部下载")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "MD5"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "请输入MD5",
              modelValue: _unref(form).md5,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).md5 = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title", "before-close"]);
    };
  }
});